import { useMutation } from '@tanstack/react-query'
import { doc, addDoc, collection, serverTimestamp, writeBatch, deleteDoc } from 'firebase/firestore'
import { db } from '@fleetops/firebase'
import { firestorePaths } from '@fleetops/types'
import type { NotificationType } from '@fleetops/types'
import { useSession } from '@/store/auth.store'

export function useMarkAllNotificationsRead() {
  const session = useSession()
  return useMutation({
    mutationFn: async (notificationIds: string[]) => {
      if (!session || notificationIds.length === 0) return
      const batch = writeBatch(db)
      for (const id of notificationIds) {
        batch.update(doc(db, firestorePaths.notification(session.tenantId, id)), { read: true })
      }
      await batch.commit()
    },
  })
}

export function useDismissNotification() {
  const session = useSession()
  return useMutation({
    mutationFn: async (notificationId: string) => {
      if (!session) return
      await deleteDoc(doc(db, firestorePaths.notification(session.tenantId, notificationId)))
    },
  })
}

export function useCreateNotification() {
  const session = useSession()
  return useMutation({
    mutationFn: async (input: {
      userId: string
      type: NotificationType
      title: string
      message: string
      damageId?: string
    }) => {
      if (!session) return
      await addDoc(collection(db, firestorePaths.notifications(session.tenantId)), {
        ...input,
        tenantId: session.tenantId,
        read: false,
        createdAt: serverTimestamp(),
      })
    },
  })
}
